import config from '@/router/config'
import Vue from 'vue'

const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: [],
    routes: [],
    isLoadRoute: false,
    thirdMenuObj: null, //三级菜单对象
    currentView: null   //当前选中的view
  },
  mutations: {
    GET_MENU: (state, menus) => {
      state.routes = menus;
    },
    LOAD_ROUTE: (state, value) => {
      state.isLoadRoute = value;
    },
    ADD_VISITED_VIEWS: (state, view) => {
      state.currentView = view; 
      var menuArray = depthFirstInTree(state.routes, view.fullPath, "children", "path");
      if(menuArray.length == 3){
        state.thirdMenuObj = menuArray[1];
      } else {
        state.thirdMenuObj = null;
      }
      if (state.visitedViews.some(v => v.path === view.fullPath)) return
      state.visitedViews.push({
        name: view.name,
        path: view.fullPath
      })
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name)
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, i + 1)
          break
        }
      }
    },
    DEL_ALL_VIEWS: (state) => {
      state.visitedViews = []
      state.cachedViews = []
    }
  },
  actions: {
    getMenu({ commit }) {
      return new Promise((resolve, reject) => {
        const { requestPath } = Vue.config;
        const SidebarConfig = config();
        hz.ajax.get(`${requestPath}/sys/menu/getUserMenuWebOnShow`).then(res => {
            if(typeof res == 'string'){ res = JSON.parse(res)};
            if(res.code == 'HZ000001' || res.code == "HZ000000"){
              //用户未登录或登录后长时间未操作,请重新登录
              reject(res.message);
            }else{
              const data = []
              res.rows.map(item => {
                if(process.env.MODULE == 'all' || item.systemSign == 'all' || item.systemSign == "pd" || item.parentId == 0){
                  item.path = item.href;
                  item.title = item.name;
                  item.hidden = item.isShow == "1" ? false : true;
                  data.push(item)
                }
              });
              data.sort((a, b) => a.id - b.id)
              const tree = listToTree(data, 0) ||[];
              const menus = tree[0] ? (tree[0].children || []) : [];
              
              commit('GET_MENU', SidebarConfig.concat(menus))
              resolve(SidebarConfig.concat(menus));
            }
        }).catch(err => {
        });
      }).catch(error => {
        reject(error);
      });
      
    },
    loadRoute({ commit }){
      commit('LOAD_ROUTE', true);
    },
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VIEWS')
        resolve([...state.visitedViews])
      })
    }
  }
}

function listToTree(data, parentId) {
  var tree = [];
  var temp;
  for (var i = 0; i < data.length; i++) {
      if (data[i].parentId == parentId) {
          var obj = data[i];
          temp = listToTree(data, data[i].id);
          if (temp.length > 0) {
           obj.children = temp;
          }
          tree.push(obj);
      }
  }
  return tree;
}
function depthFirstInTree(treeData, targetValue, key = 'items', valueKey = 'id') {
  if(treeData && treeData[valueKey] && treeData[valueKey] == targetValue) {
      return [treeData];
  }

  if(! (treeData instanceof Array) ) {
      treeData = treeData[key];
  }
  var ret = [];

  var find = function(list, arr, isFind) {
      if(!list || !list.length) {
          return;
      }
      for(var i = 0; i < list.length; i ++) {
          if(isFind) {
              return;
          }
          var model = list[i];
          arr.push(model);
          if(model[valueKey] && model[valueKey] == targetValue) {
              ret = arr;
              isFind = true;
              return;
          }
          if(model[key] && model[key].length) {
              find(model[key], arr.concat([]));
          }
          arr.pop();
      }
      if(i === list.length) {
          arr.pop();
      }
  };
  find(treeData, [], false);

  return ret.reverse();
}

export default tagsView



// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js